import { L as LanguageCode } from './index2.js';

/* eslint prefer-destructuring: warn */
const datesDictionary = {
    months: {
        bg: [['януари', 'янр'], ['февруари', 'фев'], ['март', 'мар'], ['април', 'апр'], ['май'], ['юни'], ['Юли'], ['август', 'авг'], ['септември', 'сеп'], ['октомври', 'окт'], ['ноември', 'ное'], ['декември', 'дек']],
        ca: [['gen'], ['feb'], ['mar', 'març'], ['abr'], ['mai', 'maig'], ['jun', 'juny'], ['jul'], ['ago', 'ag'], ['set'], ['oct'], ['nov'], ['des']],
        ch: [['1月'], ['2月'], ['3月'], ['4月'], ['5月'], ['6月'], ['7月'], ['8月'], ['9月'], ['10月'], ['11月'], ['12月']],
        cs: [['led'], ['úno'], ['bře'], ['dub'], ['kvě'], ['čer'], ['čvc'], ['srp'], ['zář'], ['říj'], ['lis'], ['pro']],
        da: [['januar'], ['februar'], ['marts'], ['april'], ['maj'], ['juni'], ['juli'], ['august'], ['september'], ['oktober'], ['november'], ['december']],
        de: [['jan', 'januar'], ['feb', 'februar'], ['mär', 'märz'], ['apr', 'april'], ['mai'], ['jun', 'juni'], ['jul', 'juli'], ['aug', 'august'], ['sep', 'september'], ['okt', 'oktober'], ['nov', 'november'], ['dez', 'dezember']],
        el: [['ιαν', 'Ιανουάριος'], ['φεβ', 'Φεβρουάριος'], ['μαρ', 'Μάρτιος'], ['απρ', 'Απρίλιος'], ['μαι', 'Μάϊος'], ['ιουν', 'Ιούνιος'], ['ιουλ', 'Ιούλιος'], ['αυγ', 'Αύγουστος'], ['σεπ', 'Σεπτέμβριος'], ['οκτ', 'Οκτώβριος'], ['νοε', 'Νοέμβριος'], ['δεκ', 'Δεκέμβριος']],
        en: [['jan', 'january'], ['feb', 'february'], ['mar', 'march'], ['apr', 'april'], ['may'], ['jun', 'june'], ['jul', 'july'], ['aug', 'august'], ['sep', 'september'], ['oct', 'october'], ['nov', 'november'], ['dec', 'december']],
        es: [['ene', 'enero'], ['feb', 'febrero'], ['mar', 'marzo'], ['abr', 'abril'], ['may', 'mayo'], ['jun', 'junio'], ['jul', 'julio'], ['ago', 'agosto'], ['sep', 'septiembre'], ['oct', 'octubre'], ['nov', 'noviembre'], ['dic', 'diciembre']],
        et: [['jaanuar', 'jaan'], ['veebruar', 'veebr'], ['märts'], ['aprill', 'apr'], ['mai'], ['juuni'], ['juuli', 'juuli'], ['august', 'aug'], ['september', 'sept'], ['oktoober', 'okt'], ['november', 'nov'], ['detsember', 'dets']],
        fi: [['tammikuu', 'tammikuun', 'tammikuuta', 'tammi'], ['helmikuu', 'helmikuun', 'helmikuuta', 'helmi'], ['maaliskuu', 'maaliskuun', 'maaliskuuta', 'maalis'], ['huhtikuu', 'huhtikuun', 'huhtikuuta', 'huhti'], ['toukokuu', 'toukokuun', 'toukokuuta', 'touko'], ['kesäkuu', 'kesakuu', 'kesakuun', 'kesakuuta', 'kesa', 'kesä'], ['heinäkuu', 'heinakuu', 'heinakuun', 'heinakuuta', 'heina', 'heinä'], ['elokuu', 'elokuun', 'elokuuta', 'elo'], ['syyskuu', 'syyskuun', 'syyskuuta', 'syys'], ['lokakuu', 'lokakuun', 'lokakuuta', 'loka'], ['marraskuu', 'marraskuun', 'marraskuuta', 'marras'], ['joulukuu', 'joulukuun', 'joulukuuta', 'joulu']],
        fr: [['janv', 'jan', 'janvier'], ['févr', 'fév', 'fev', 'février'], ['mars', 'mar'], ['avril', 'avr'], ['mai'], ['juin', 'jun'], ['juil', 'jul', 'juillet'], ['août', 'aou', 'aoû'], ['sept', 'sep', 'septembre'], ['oct', 'octobre'], ['nov', 'novembre'], ['déc', 'décembre']],
        hr: [['sij'], ['velj'], ['ožu'], ['tra'], ['svi'], ['lip'], ['srp'], ['kol'], ['ruj'], ['lis'], ['stu'], ['pro']],
        hu: [['jan'], ['feb'], ['már'], ['ápr'], ['máj'], ['jún'], ['júl'], ['aug'], ['szep'], ['okt'], ['nov'], ['dec']],
        id: [['januari', 'jan', 'djan'], ['februari', 'peb', 'feb'], ['maret', 'Mrt', 'mar'], ['april', 'apr'], ['mei', 'mai'], ['juni', 'djuni', 'jun'], ['juli', 'djuli', 'jul'], ['augustus', 'ag', 'aug'], ['september', 'sept', 'sep'], ['oktober', 'nop', 'okt'], ['november', 'nop', 'nov'], ['desember', 'des']],
        is: [['jan.', 'jan'], ['febr.', 'feb.', 'feb'], ['mars.', 'mar.'], ['apr.', 'ap.', 'apr'], ['maí'], ['jún.', 'jún'], ['júl.', 'júl'], ['ág.', 'ágú.', 'ágú'], ['sep.', 'sept.', 'sep'], ['okt.', 'okt'], ['nóv.', 'nóv'], ['des.', 'des']],
        it: [['gen', 'gennaio'], ['feb', 'febbraio'], ['mar', 'marzo'], ['apr', 'aprile'], ['mag', 'maggio'], ['giu', 'giugno'], ['lug', 'luglio'], ['ago', 'agosto'], ['set', 'settembre'], ['ott', 'ottobre'], ['nov', 'novembre'], ['dic', 'dicembre']],
        ja: [['1月', 'いちがつ', '一月'], ['2月', 'にがつ', '二月'], ['3月', 'さんがつ', '三月'], ['4月', 'しがつ', '四月'], ['5月', 'ごがつ', '五月'], ['6月', 'ろくがつ', '六月'], ['7月', 'しちがつ', '七月'], ['8月', 'はちがつ', '八月'], ['9月', 'くがつ', '九月'], ['10月', 'じゅうがつ', '十月'], ['11月', 'じゅういちがつ', '十一月'], ['12月', 'じゅうにがつ', '十二月']],
        lv: [['jan'], ['feb'], ['mar'], ['apr'], ['mai'], ['jūn'], ['jūl'], ['aug'], ['sep'], ['okt'], ['nov'], ['dec']],
        ms: [['januari', 'jan'], ['februari', 'feb'], ['mac'], ['april', 'apr'], ['mungkin', 'mei'], ['jun'], ['julai'], ['ogos', 'og'], ['september', 'sept'], ['oktober', 'okt'], ['november', 'nov'], ['disember', 'dis']],
        nb: [['januar'], ['februar'], ['mars'], ['april'], ['mai'], ['juni'], ['july'], ['august'], ['september'], ['oktober'], ['november'], ['desember']],
        nl: [['jan'], ['feb'], ['mrt'], ['apr'], ['mei'], ['jun'], ['jul'], ['aug'], ['sep'], ['okt'], ['nov'], ['dec']],
        no: [['jan'], ['feb'], ['mar'], ['apr'], ['mai'], ['jun'], ['jul'], ['aug'], ['sep'], ['okt'], ['nov'], ['des']],
        pl: [['sty'], ['lu'], ['mar'], ['kw'], ['maj'], ['cze'], ['lip'], ['sie'], ['wrz'], ['pa'], ['lis'], ['gru']],
        pt: [['jan', 'janeiro'], ['fev', 'fevereiro'], ['mar', 'março'], ['abr', 'abril'], ['mai', 'maio'], ['jun', 'junho'], ['jul', 'julho'], ['ago', 'agosto'], ['set', 'setembro'], ['out', 'outubro'], ['nov', 'novembro'], ['dez', 'dezembro']],
        ro: [['ianuarie', 'gerar', 'ian'], ['februarie', 'făurar', 'feb'], ['martie', 'mărțișor', 'mar'], ['aprilie', 'prier', 'apr'], ['mai', 'florar'], ['iunie', 'cireșar', 'iun'], ['iulie', 'cuptor', 'iul'], ['august', 'gustar', 'aug'], ['septembrie', 'răpciune', 'viniceriu', 'sept'], ['octombrie', 'brumărel', 'oct'], ['noiembrie', 'brumar', 'noiem', 'noi', 'nov'], ['decembrie', 'undrea', 'dec']],
        ru: [['янв', 'январь'], ['фев', 'февраль'], ['мар', 'март'], ['апр', 'апрель'], ['май'], ['июн', 'июнь'], ['июл', 'июль'], ['авг', 'август'], ['сен', 'сентябрь'], ['окт', 'октябрь'], ['ноя', 'ноябрь'], ['дек', 'декабрь']],
        sk: [['jan'], ['feb'], ['mar'], ['apr'], ['máj'], ['jún'], ['júl'], ['aug'], ['sep'], ['okt'], ['nov'], ['dec']],
        sl: [['jan'], ['feb'], ['mar'], ['apr'], ['maj'], ['jun'], ['jul'], ['avg'], ['sep'], ['okt'], ['nov'], ['dec']],
        sv: [['jan'], ['feb'], ['mar'], ['apr'], ['maj', 'mai'], ['jun'], ['jul'], ['aug'], ['sep'], ['okt'], ['nov'], ['dec']],
        sq: [['Janar'], ['shkurt'], ['mars'], ['prill'], ['maj'], ['qershor'], ['korrik'], ['gusht'], ['shtator'], ['tetor'], ['nëntor'], ['dhjetor']],
        sr: [['januar'], ['februar'], ['mart'], ['april'], ['maj'], ['jun'], ['jul'], ['avgust'], ['septembar'], ['oktobar'], ['novembar'], ['decembar']],
        th: [['มกราคม', 'ม.ค.'], ['กุมภาพันธ์', 'ก.พ.'], ['มีนาคม', 'มี.ค.'], ['เมษายน', 'เม.ย.'], ['พฤษภาคม', 'พ.ค.'], ['มิถุนายน', 'มิ.ย.'], ['กรกฎาคม', 'ก.ค.'], ['สิงหาคม', 'ส.ค.'], ['กันยายน', 'ก.ย.'], ['ตุลาคม', 'ต.ค.'], ['พฤศจิกายน', 'พ.ย.'], ['ธันวาคม', 'ธ.ค.']],
        tr: [['oca'], ['şub'], ['mar'], ['nis'], ['may'], ['haz'], ['tem'], ['ağu'], ['eyl'], ['eki'], ['kas'], ['ara']],
        uk: [['січень'], ['лютий'], ['березень', 'березня'], ['квітень'], ['травень'], ['червень'], ['липень'], ['серпень'], ['вересень'], ['жовтень'], ['листопад'], ['грудень']],
        zh: [['一月'], ['二月'], ['三月'], ['四月'], ['五月'], ['六月'], ['七月'], ['八月'], ['九月'], ['十月'], ['十一月'], ['十二月']],
        ko: [['1월'], ['2월'], ['3월'], ['4월'], ['5월'], ['6월'], ['7월'], ['8월'], ['9월'], ['10월'], ['11월'], ['12월']],
        ar: [['يناير'], ['فبراير'], ['مارس'], ['أبريل'], ['مايو'], ['يونيو'], ['يوليو'], ['أغسطس'], ['سبتمبر'], ['أكتوبر'], ['نوفمبر'], ['ديسمبر']],
        vi: [['Th01'], ['Th02'], ['Th03'], ['Th04'], ['Th05'], ['Th06'], ['Th07'], ['Th08'], ['Th09'], ['Th10'], ['Th11'], ['Th12']],
    },
    weekDays: [
        ['domingo', 'sunday', 'dimanche', 'domenica', 'sonntag', 'sun', 'sunnuntai', 'su', '일요일', '日曜日', 'にちようび', 'ahad', 'nedjalja', 'неділя', 'pühapäev', 'الأحد'],
        ['lunes', 'monday', 'lundi', 'lunedi', 'montag', 'mon', 'maanantai', 'ma', '월요일', '月曜日', 'げつようび', 'isnin', 'ponedjeljak', 'понеділок', 'esmaspäev', 'الاثنين'],
        ['martes', 'tuesday', 'mardi', 'martedi', 'dienstag', 'tue', 'tiistai', 'ti', '화요일', '火曜日', 'かようび', 'selasa', 'utorak', 'вівторок', 'teisipäev', 'الثلاثاء'],
        ['miercoles', 'wednesday', 'mercredi', 'mercoledi', 'mittwoch', 'wed', 'keskiviikko', 'ke', '수요일', '水曜日', 'すいようび', 'hari rabu', 'srijeda', 'середа', 'kolmapäev', 'الأربعاء'],
        ['jueves', 'thursday', 'jeudi', 'giovedi', 'donnerstag', 'thu', 'torstai', 'to', '목요일', '木曜日', 'もくようび', 'khamis', 'četvrtak', 'четвер', 'neljapäev', 'الخميس'],
        ['viernes', 'friday', 'vendredi', 'venerdì', 'freitag', 'fri', 'perjantai', 'pe', '금요일', '金曜日', 'きんようび', 'jumaat', 'petak', "п'ятниця", 'reede', 'الجمعة'],
        ['sábado', 'sabado', 'saturday', 'samedi', 'sabato', 'samstag', 'sat', 'lauantai', 'la', '토요일', '土曜日', 'どようび', 'sabtu', 'subota', 'субота', 'laupäev', 'السبت'],
    ],
};
const wchar = '[A-Za-z\u00C0-\u017F]';
const regexs = [
    `(${wchar}*)\\s*([0-9]+)\\s+(([a-zA-Zá-úà-ùä-üâ-ûşğūřěčžç.]*)|([0-9]*月)|([АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя]*)|([α-ωΑ-Ω]*)) 20([0-9]*)`,
    `(${wchar}+)\\s+([0-9]{1,2}),\\s+([0-9]{4})`,
    `([0-9]{1,2})/(${wchar}*)(|.)/([0-9]{4})`,
    `([0-9]{1,2})-(${wchar}{3})-([0-9]{2,4})`,
    `([0-9]{1,2})\\.? (${wchar}*)\\.? ([0-9]{4})`,
    `([0-9]{1,4})\\s+(${wchar}{3})\\s+([0-9]{2,4})`,
    '([0-9]{1,2})\\s+([^\\d\\s]*)\\s+([0-9]{4})',
    // 7 - examples: '21 de Março de 2017', '21 of March of 2017'
    `(\\d+)[^\\d]+?(${wchar}{4,50})[^\\d]+(\\d{4})`,
    // 8 - examples: 'Sun, Feb 25 2018 ', ' Mon, Feb 26 2018', 'Thu, 3 Jul 2025'
    '(\\S+)\\s+(\\d{1,2})\\s+(\\d{4})',
    // 9 - (PT) Segunda 3 de Dezembro de 2018
    `(\\S+)\\s+(\\d+)[^\\d]+?(${wchar}{4,50})[^\\d]+(\\d{4})`,
    // 10 - (KR) 12월 19, 2018
    '(\\d+)([\\D]+)?[월月][\\D]+(\\d*)[\\D]+(\\d{4})($|[\\D])',
    // 11 - (JP) 2023年3月1日水曜日, (KR) 2023년 3월 1일 수요일
    '(\\d+)([\\D]+)?[년|年](\\s)?(\\d+)([\\D]+)?[월|月](\\s)?(\\d+)([\\D]+)?[일|日]',
    // 12 - (ZH) 六月 13, 2023 | (RU) Июнь 21, 2023 | (EL) Οκτώβριος 16, 2024 | (TH) มิถุนายน 15, 2023
    '([\\u4E00-\\u9FA5А-Яа-яΑ-Ωα-ωάέήίόύώϊϋΐΰก-๙]+)\\s(\\d{1,2}),\\s(\\d{4})',
    // 13 - Fri 15th Sep 2023
    `(\\s+(\\d{1,2})(?:st|nd|rd|th)?\\s+(${wchar}{3})\\s+(\\d{4}))`,
    // 14 - 20 Th08 2024
    `([0-9]{2})\\s*${wchar}{2}([0-9]{2})\\s*([0-9]{4})`,
];
function translateDate(originalInput, language = LanguageCode.English) {
    let date;
    let result;
    let regxp;
    let i;
    const input = originalInput.trim();
    const supportedLanguage = language in datesDictionary.months;
    if (!supportedLanguage) {
        return undefined;
    }
    // Once we are sure the language of the call is "supported" (exists in datesDictionary.months)
    // It is safe to hint TS about that fact.
    const lang = language;
    // Check all Regexs
    for (i = 0; i < regexs.length; i += 1) {
        regxp = new RegExp(regexs[i], 'i');
        result = input.match(regxp);
        if (result != null) {
            let day;
            let month;
            let year;
            let monthString;
            let monthSubstring;
            // console.log(i); console.log(result);
            // First Case
            if (i === 0) {
                // Day
                day = result[2];
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        // console.log(result[3].toLowerCase().replace('.', '') + ' - ' + dates_dictionary.months[lang][j][k]);
                        if (result[3].toLowerCase().replace('.', '') === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
                // Year
                year = `20${result[8]}`;
            }
            else if (i === 1) { // BS 7
                // Day and YEar
                day = result[2];
                year = result[3];
                monthString = result[1].toLowerCase().replace('.', '').substr(0, 3);
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (monthString === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 2) { // BS 7 French
                // Day and YEar
                day = result[1];
                year = result[4];
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (result[2].toLowerCase().replace('.', '') === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 3) { // BS 7 Spanish
                // Day and YEar
                day = result[1];
                year = (result[3].length === 2 ? (new Date().getFullYear().toString().slice(0, 2)) : '') + result[3]; // sometimes we can have '16' instead of '2016'
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (result[2].toLowerCase().replace('.', '') === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 4) { // BS 7 Deutsch
                // Day and YEar
                day = result[1];
                year = result[3];
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (result[2].toLowerCase().replace('.', '') === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 5) { // Spalopia
                // Day and Year
                day = result[1];
                year = result[3];
                // Year / Month / Day
                if (day.length === 4) {
                    day = result[3];
                    year = result[1];
                }
                if (year.length === 2) {
                    year = `20${year}`;
                }
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (result[2].toLowerCase().replace('.', '') === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 6 || i === 7) { // 6 -> Fastbooking, 7 -> Dit-it
                // Day and YEar
                day = result[1];
                year = result[3];
                monthString = result[2].toLowerCase();
                monthSubstring = monthString.substr(0, 3);
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (monthString === datesDictionary.months[lang][j][k]
                            || monthSubstring === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 8) { // 8 - Protel
                // Day and YEar
                day = result[2];
                year = result[3];
                monthString = result[1].toLowerCase();
                monthSubstring = monthString.substr(0, 3);
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (monthString === datesDictionary.months[lang][j][k]
                            || monthSubstring === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 10) { // 10 - (KR) 12월 19, 2018
                day = result[3];
                month = result[1];
                year = result[4];
            }
            else if (i === 11) { // 11 - (KR) '2023년 3월 1일' (JP) '2023年3月1日水曜日'
                day = result[7];
                month = result[4];
                year = result[1];
            }
            else if (i === 12) { // 12 - (ZH) 六月 13, 2023 | (RU) Июнь 21, 2023 | (EL) Οκτώβριος 16, 2024 | (TH) มิถุนายน 15, 2023
                day = result[2];
                monthString = result[1].toLowerCase();
                monthSubstring = monthString.substr(0, 3);
                year = result[3];
                monthString = result[1].toLowerCase();
                monthSubstring = monthString.substr(0, 3);
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (monthString === datesDictionary.months[lang][j][k] || monthSubstring === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 13) { // 13 - Fri 15th Sep 2023
                day = result[2];
                monthString = result[3].toLowerCase();
                monthSubstring = monthString.substr(0, 3);
                year = result[4];
                // Translate Month if posible
                for (let j = 0; j < datesDictionary.months[lang].length; j += 1) {
                    for (let k = 0; k < datesDictionary.months[lang][j].length; k += 1) {
                        if (monthString === datesDictionary.months[lang][j][k]
                            || monthSubstring === datesDictionary.months[lang][j][k]) {
                            month = j + 1;
                            break;
                        }
                    }
                }
            }
            else if (i === 14) { // 14 - 20 Th08 2024
                day = result[1];
                month = result[2];
                year = result[3];
            }
            if ((typeof day !== 'undefined') && (typeof month !== 'undefined') && (typeof year !== 'undefined')) {
                date = `${year}/${(`0${month}`).substr(-2)}/${(`0${day}`).substr(-2)}`;
                break;
            }
        }
    }
    return date;
}

export { translateDate as t };
